/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

const __unstableBlockNameContext = createContext( '' );

export default __unstableBlockNameContext;
